export default "__VITE_ASSET__BGNg5rZX__"